import { elementsCssVarNameDefinitions } from '../../../styles/theme'

export function writeHeaderHeightToCssVar(headerHeight: number) {
  if (typeof window === 'undefined') return
  document.documentElement.style.setProperty(elementsCssVarNameDefinitions.appHeaderHeight, `${headerHeight}px`)
}
